import React from "react";
import styles from "./gender.module.css";
import { ReactComponent as ImageMale } from "./male.svg";
import { ReactComponent as ImageFemale } from "./female.svg";
import { ReactComponent as ImageOther } from "./other.svg";
import { Link } from "react-router-dom";
import { setGender } from "../../store/stateSlice";
import { useDispatch } from "react-redux";


const YourGender = () => {
  const dispatch = useDispatch();
  
  return (
    <div className={styles.container_gender}>
      <div className={styles.image_male} onClick={() => dispatch(setGender("male"))}>
        <Link to={"./your-name"}>
          <div className={styles.image_gender}>
            <ImageMale />
            <p className={styles.gender_text}>male</p>
          </div>
        </Link>
      </div>
      <div className={styles.image_female} onClick={() => dispatch(setGender("female"))}>
        <Link to={"./your-name"}>
          <div className={styles.image_gender}>
            <ImageFemale />
            <p className={styles.gender_text}>female</p>
          </div>
        </Link>
      </div>
      <div className={styles.image_female}>
        <Link to={"./your-name"}>
          <div className={styles.image_gender}>
            <ImageOther />
            <p className={styles.gender_text}>other</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export { YourGender };
